import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"
import _imports_0 from './assets/img/logo.png'


const _hoisted_1 = { class: "header" }

import { useStore } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue'
// 获取 store 实例

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
// 导航栏数据
const navs = ref([
  { name: '首页', path: '/' },
  { name: '产品服务', path: '/product' },
  { name: '数据服务解决方案', path: '/dataSolutions' },
  { name: '互联金融服务解决方案', path: '/financialSolutions' },
  { name: '关于我们', path: '/about' }
])
// 轮播图高度
let bannerHeight = store.state.bannerHeight
// 导航栏背景色
const navBackgroundColor = ref('rgb(0 0 0 / 0%)')
// 监听滚动事件
const handleScroll = () => {
  if (window.scrollY >= bannerHeight) {
    navBackgroundColor.value = 'rgb(0 0 0 / 40%)'; // 根据需要改变颜色
  } else {
    navBackgroundColor.value = 'rgb(0 0 0 / 0%)'; // 根据需要改变颜色
  }
}
// 监听 bannerHeight 的变化
store.subscribe((mutation, state) => {
  console.log(111111111111111111111111111)
  if (mutation.type === 'setbannerHeight') {
    bannerHeight = state.bannerHeight;
  }else if (mutation.type ==='setnavBgColor') {
    navBackgroundColor.value = state.navBgColor;
  }
});
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      style: _normalizeStyle({ backgroundColor: navBackgroundColor.value })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navs.value, (nav) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: nav.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(nav.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 256))
        ])
      ])
    ], 4),
    _createVNode(_component_router_view)
  ], 64))
}
}

})